// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nh-c";
export var backButton = "_nh-4";
export var backIcon = "_nh-5";
export var chevronShortcut = "_nh-6";
export var container = "_nh-1";
export var editor = "_nh-8";
export var editorWrapper = "_nh-7";
export var prefix = "_nh-2";
export var searchIcon = "_nh-3";
export var suffix = "_nh-9";
export var suffixContent = "_nh-a";
export var suffixText = "_nh-b";
export var wrapper = "_nh-0";